import React from "react";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";

const Wrapper = styled.ul`
    margin: 20px 0 10px 0;
    padding: 15px;
    width: 100%;
    color: #ff9bac;
    list-style-type: none;
`;

const ErrorWrapper = styled.li`
    position: relative;

    &:before {
        content: "\u25CB";
        position: absolute;
        right: -25px;
        top: 3px;
    }
`;
const Error = ({ message }: { message: string }) => (
    <ErrorWrapper>
        <FormattedMessage id={`form.${message}`} />
    </ErrorWrapper>
);

interface ValidationErrorsProps {
    show: boolean;
    errors: Array<string>;
}
export class ValidationErrors extends React.Component<ValidationErrorsProps> {
    render() {
        const { show, errors } = this.props;

        if (!show) {
            return null;
        }

        return (
            <Wrapper>
                {errors.map((m) => (
                    <Error key={m} message={m} />
                ))}
            </Wrapper>
        );
    }
}
